import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';

import useGetMyInfoQuery from '~hooks/query/user/useMyInfoQuery';

import ChartContent from './ChartContent';
import SignupNudgeChart from './SignupNudgeChart';
import { S } from './style';

function EmployeeBarChart() {
  const router = useRouter();
  const { isActiveUser } = useGetMyInfoQuery();
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const [path, hash] = router.asPath.split('#');

    if (wrapperRef.current && hash === 'employee-barchart') {
      if (window) {
        router.replace(path);
        wrapperRef.current.scrollIntoView();
      }
    }
  }, [router.asPath]);

  return (
    <S.StyledEmployeeBarChart isActiveUser={isActiveUser} ref={wrapperRef}>
      {isActiveUser ? <ChartContent /> : <SignupNudgeChart />}
    </S.StyledEmployeeBarChart>
  );
}

export default EmployeeBarChart;
